
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;


//const API_BASE_URL =  'https://aura-backend-node-mlfv.vercel.app/';
// const API_BASE_URL =  "http://localhost:4000/";
console.log("API_BASE_URL", API_BASE_URL);
console.log("process.env.REACT_APP_API_URL", process.env.REACT_APP_API_URL);


class ApiService {
  constructor() {
    this.api = axios.create({
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Create a separate instance for public endpoints (no auth redirect)
    this.publicApi = axios.create({
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    //  Request interceptor to add auth token and tenant_id
    this.api.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('aura_token');
        const tenantId = localStorage.getItem('aura_tenant_id');

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        if (tenantId) {
          config.headers['x-tenant-id'] = tenantId;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // Response interceptor to handle auth errors
    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          localStorage.removeItem('aura_token');
          window.location.href = '/login';
        }
        return Promise.reject(error);
      }
    );
  }

  setAuthToken(token) {
    console.log("setting auth token to header");
    if (token) {
      this.api.defaults.headers.Authorization = `Bearer ${token}`;
      console.log("token is set to header");
    } else {
      delete this.api.defaults.headers.Authorization;
    }
  }

  userActions(action, entity_id, entity_type) {
    return this.api.post('/api/user/actions', {
      action: action,
      entity_id: entity_id,
      entity_type: entity_type
    });
  }

  setTenantId(tenantId) {
    console.log("setting tenant id to header");
    if (tenantId) {
      this.api.defaults.headers['x-tenant-id'] = tenantId;
      console.log("tenant id is set to header:", tenantId);
    } else {
      delete this.api.defaults.headers['x-tenant-id'];
    }
  }


  webresearch(search_prompt) {
    return this.api.post('/api/features/webresearch', {
      search_prompt: search_prompt
    });
  }


  // Auth endpoints
  googleLogin(token) {
    return this.publicApi.post('/api/auth/google-login', {
      token: token
    });
  }

  sendMagicLink(email, isInExtension) {
    console.log("called sendmagic link at time", new Date().toISOString());
    console.log("email", email);
    return this.publicApi.post('/api/auth/magic-link?isInExtension=' + isInExtension, {
      email: email,
    });
  }

  verifyAuth() {
    return this.api.get('/api/auth/verify-auth');
  }

  // User usage statistics
  getUserUsageStats() {
    return this.api.get('/api/user/usage-stats');
  }

  // Insights routes (POST endpoints)
  getDealInsights(hsObjectId, tenantId) {
    console.log("called getDealInsights at time", new Date().toISOString());
    return this.api.post('/api/insights/deal-service-bundle', {
      hs_object_id: hsObjectId,
      tenantId: tenantId
    });
  }

  generateBattlecard(prospect, persona, usecase, context) {
    return this.api.post('/api/collateral/battlecard', {
      prospect,
      persona,
      usecase,
      context
    });
  }

  getBattlecardById(key) {
    return this.api.get(`/api/collateral/battlecard/${key}`);
  }

  getCompanyInsights(hsObjectId, tenantId) {
    return this.api.post('/api/insights/company-service-bundle', {
      hs_object_id: hsObjectId,
      tenantId: tenantId
    });
  }

  /**
   * Fetch all stored signals for a HubSpot company object ID.
   * Tenant resolved server-side from auth token.
   */
  getSignalsBySourceId(sourceId) {
    return this.api.get(`/api/signals/by-source?source_id=${sourceId}`);
  }

  /**
   * Create a HubSpot task associated with a company, linked to a specific signal.
   * Tenant resolved server-side from auth token.
   */
  createSignalTask({ companySourceId, taskSubject, taskBody }) {
    return this.api.post('/api/signals/create-task', {
      company_source_id: companySourceId,
      task_subject: taskSubject,
      task_body: taskBody,
    });
  }

  // HubSpot routes
  getHsDealData(hsObjectId, tenantId) {
    console.log("called getHsDealData at time", new Date().toISOString());
    return this.api.post('/api/hubspot/get-hs-deal-data', {
      hs_object_id: hsObjectId,
      tenantId: tenantId
    });
  }

  getHsLastActivity(hsObjectId, tenantId) {
    return this.api.post('/api/hubspot/get-hs-last-activity', {
      hs_object_id: hsObjectId,
      tenantId: tenantId
    });
  }

  addNote(noteText, dealId, timestamp, tenantId) {
    return this.api.post('/api/hubspot/add-note', {
      noteText,
      dealId,
      timestamp,
      tenantId
    });
  }

  getCompaniesCollateralBySlug(slug) {
    return this.api.get(`/api/companies-collateral/${slug}`);
  }
  editCompnayCollateral(slug, query, versionIndex = 0) {
    return this.api.post('/api/companies-collateral/edit', {
      slug: slug,
      query: query,
      versionIndex: versionIndex
    });
  }
  createTask(task_body, task_subject, deal_id, tenantId) {
    return this.api.post('/api/hubspot/create-task', {
      task_body,
      task_subject,
      deal_id,
      tenantId
    });
  }

  createBulkTask(task, deal_id, tenantId) {

    return this.api.post('/api/hubspot/create-bulk-task', {
      task,
      deal_id,
      tenantId
    });
  }

  // Features routes
  getNbaTemplates() {
    return this.api.get('/api/features/nba-templates');
  }

  generateFromTemplate(hsObjectId, templateId) {
    return this.api.post('/api/features/generate-from-template', {
      hs_object_id: hsObjectId,
      template_id: templateId,
    });
  }

  executeNba(hsObjectId, nbaIndex, tenantId, entityId, templateId, fieldsToBeUpdated) {
    return this.api.post('/api/features/nba-execution-case1', {
      hs_object_id: hsObjectId,
      nba_index: nbaIndex,
      tenantId: tenantId,
      entity_id: entityId,
      ...(templateId ? { template_id: templateId } : {}),
      ...(fieldsToBeUpdated ? { fields_to_be_updated: fieldsToBeUpdated } : {}),
    });
  }

  getAriyaHandoff(documentId, contactEmail) {
    return this.api.post('/api/features/ariya-handoff', {
      document_id: documentId,
      contact_email: contactEmail,
    });
  }

  gettailspinCollateral(key) {
    return this.api.get(`/api/collateral/collateral/${key}`);
  }

  gettailspinCollateralBySlug(slug) {
    return this.api.get(`/api/tailspin/collateral/slug/${slug}`);
  }
  getCollateral(key) {
    return this.api.get(`/api/collateral/${key}`);
  }

  getCollateralwithTemplate(key) {
    return this.api.get(`/api/collateral/withTemplate/${key}`);
  }

  // Fetch new_entity_insight_collateral by slug, returned in TailspinCollateral version format
  getInsightCollateralBySlug(slug) {
    return this.api.get(`/api/collateral/insight-slug/${slug}`);
  }

  // Save visual-editor changes back to new_entity_insight_collateral
  updateInsightCollateral(slug, payload) {
    return this.api.put(`/api/collateral/insight-slug/${slug}`, payload);
  }

  editCollateral(collateral_id, query) {
    return this.api.post('/api/features/edit-collateral', {
      collateral_id: collateral_id,
      query: query
    });
  }

  saveCollateral(entityId, emailMessage, pdf, tenantId, nbaIndex) {
    return this.api.post('/api/features/collateral/save', {
      entity_id: entityId,
      email_message: emailMessage,
      pdf: pdf,
      tenantId: tenantId,
      nba_index: nbaIndex
    });
  }

  // Admin routes
  getAccountsStats() {
    return this.api.get('/api/admin/accounts/stats');
  }

  // Deal insights with page content data (Without App)
  getdealinsightswithouttoken(hsObjectId, data) {
    return this.api.post('/api/withoutToken/deal-service-bundle', {
      hs_object_id: hsObjectId,
      data: data
    });
  }

  // Company insights without app
  getCompanyInsightsWithoutApp(hsObjectId, data) {
    return this.api.post('/api/withoutToken/company-service-bundle', {
      hs_object_id: hsObjectId,
      data: data
    });
  }

  // NBA execution without app
  executeNbaWithoutApp(hsObjectId, nbaIndex, entityId, data) {
    return this.api.post('/api/withoutToken/features/nba-execution', {
      hs_object_id: hsObjectId,
      nba_index: nbaIndex,
      entity_id: entityId,
      data: data
    });
  }

  //is app installed
  isappinstalled() {
    return this.api.get('/api/tenant/is-app-installed');
  }

  // Companies endpoints
  getAllCompanies() {
    return this.api.get('/api/companies');
  }

  getCompanyById(companyId) {
    return this.api.get(`/api/companies/${companyId}`);
  }

  createCompany(companyData) {
    return this.api.post('/api/companies', companyData);
  }

  updateCompanyIntelligence(companyId, intelligenceJson) {
    return this.api.put(`/api/companies/${companyId}/intelligence`, {
      intelligence_json: intelligenceJson
    });
  }

  // Prospects endpoints
  getAllProspects() {
    return this.api.get('/api/prospects');
  }

  getProspectById(prospectId) {
    return this.api.get(`/api/prospects/${prospectId}`);
  }

  getProspectsByCompanyId(companyId) {
    return this.api.get(`/api/prospects/company/${companyId}`);
  }

  createProspect(prospectData) {
    return this.api.post('/api/prospects', prospectData);
  }

  updateProspectIntelligence(prospectId, intelligenceJson) {
    return this.api.put(`/api/prospects/${prospectId}/intelligence`, {
      intelligence_json: intelligenceJson
    });
  }

  // Companies Collateral endpoints
  getAllCollaterals(companyId = null) {
    const url = companyId
      ? `/api/companies-collateral?company_id=${companyId}`
      : '/api/companies-collateral';
    return this.api.get(url);
  }

  getCollateralById(collateralId) {
    return this.api.get(`/api/companies-collateral/${collateralId}`);
  }

  getCollateralsByCompanyId(companyId) {
    return this.api.get(`/api/companies-collateral/company/${companyId}`);
  }

  getCollateralBySlug(slug, companyId = null) {
    const url = companyId
      ? `/api/companies-collateral/slug/${slug}?companyId=${companyId}`
      : `/api/companies-collateral/slug/${slug}`;
    return this.api.get(url);
  }

  createCollateral(collateralData) {
    return this.api.post('/api/companies-collateral', collateralData);
  }

  editTailspinCollateral(slug, query, versionIndex, collateralId = null, updateExisting = false) {
    return this.api.post('/api/tailspin/collateral/edit', {
      slug: slug,
      query: query,
      versionIndex: versionIndex,
      collateralId: collateralId,
      updateExisting: updateExisting
    });
  }


  // Utility methods
  async getDealInsightsWithRetry(hsObjectId, tenantId, maxRetries = 3) {
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const response = await this.getDealInsights(hsObjectId, tenantId);
        return { data: response.data, error: null };
      } catch (error) {
        if (attempt === maxRetries) {
          return { data: null, error: error.message };
        }
        // Wait before retrying (exponential backoff)
        await new Promise(resolve => setTimeout(resolve, Math.pow(2, attempt) * 1000));
      }
    }
  }

  async getCompanyInsightsWithRetry(hsObjectId, tenantId, maxRetries = 3) {
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const response = await this.getCompanyInsights(hsObjectId, tenantId);
        return { data: response.data, error: null };
      } catch (error) {
        if (attempt === maxRetries) {
          return { data: null, error: error.message };
        }
        // Wait before retrying (exponential backoff)
        await new Promise(resolve => setTimeout(resolve, Math.pow(2, attempt) * 1000));
      }
    }
  }

  // Batch operations
  async batchGetDealInsights(dealIds, tenantId) {
    const promises = dealIds.map(id => this.getDealInsights(id, tenantId));
    try {
      const results = await Promise.allSettled(promises);
      return results.map((result, index) => ({
        dealId: dealIds[index],
        success: result.status === 'fulfilled',
        data: result.status === 'fulfilled' ? result.value.data : null,
        error: result.status === 'rejected' ? result.reason.message : null
      }));
    } catch (error) {
      return { data: null, error: error.message };
    }
  }

  async batchGetCompanyInsights(companyIds, tenantId) {
    const promises = companyIds.map(id => this.getCompanyInsights(id, tenantId));
    try {
      const results = await Promise.allSettled(promises);
      return results.map((result, index) => ({
        companyId: companyIds[index],
        success: result.status === 'fulfilled',
        data: result.status === 'fulfilled' ? result.value.data : null,
        error: result.status === 'rejected' ? result.reason.message : null
      }));
    } catch (error) {
      return { data: null, error: error.message };
    }
  }

  // Generic helper methods
  async handleApiCall(apiCall, errorMessage = 'API call failed') {
    try {
      const response = await apiCall();
      return { data: response.data, error: null };
    } catch (error) {
      console.error(errorMessage, error);
      return {
        data: null,
        error: error.response?.data?.error || error.message || errorMessage
      };
    }
  }

  // Tailspin Onboarding endpoints
  generateProductDescriptions(companyDomain) {
    return this.api.post('/api/tailspin/onboarding/step1/generate_intelligence', {
      companyDomain: companyDomain
    });
  }

  updateOnboardingProduct(productId, updates) {
    return this.api.put(`/api/tailspin/onboarding/step1/product/${productId}`, updates);
  }

  fetchAssets(searchQuery, tag, type) {
    return this.api.post('/api/tailspin/onboarding/step2/fetch-assets', {
      searchQuery: searchQuery,
      tag: tag,
      type: type
    });
  }

  updateOnboardingAsset(tag, updates) {
    return this.api.put(`/api/tailspin/onboarding/step2/asset/${tag}`, updates);
  }

  completeOnboarding() {
    return this.api.post('/api/tailspin/onboarding/complete');
  }

  // Tailspin Products
  getTailspinProducts() {
    return this.api.get('/api/tailspin/products');
  }

  createTailspinProduct(productData) {
    return this.api.post('/api/tailspin/products', productData);
  }

  updateTailspinProduct(productId, productData) {
    return this.api.put(`/api/tailspin/products/${productId}`, productData);
  }

  deleteTailspinProduct(productId) {
    return this.api.delete(`/api/tailspin/products/${productId}`);
  }

  // Tailspin Prospects
  getTailspinProspects(params = {}) {
    const searchParams = new URLSearchParams();

    if (params.page) {
      searchParams.append('page', params.page);
    }

    if (params.pageSize) {
      searchParams.append('pageSize', params.pageSize);
    }

    const query = searchParams.toString();
    const url = query ? `/api/tailspin/prospects?${query}` : '/api/tailspin/prospects';

    return this.api.get(url);
  }

  createTailspinProspect(prospectData) {
    return this.api.post('/api/tailspin/prospects', prospectData);
  }

  updateTailspinProspect(prospectId, prospectData) {
    return this.api.put(`/api/tailspin/prospects/${prospectId}`, prospectData);
  }

  deleteTailspinProspect(prospectId) {
    return this.api.delete(`/api/tailspin/prospects/${prospectId}`);
  }

  // Tailspin Assets
  getTailspinAssets() {
    return this.api.get('/api/tailspin/assests');
  }

  updateTailspinAssets(updates) {
    return this.api.put('/api/tailspin/assests', { updates });
  }

  // Tailspin Image Upload
  uploadTailspinImages(files, options = {}) {
    const formData = new FormData();
    
    // Add files
    if (Array.isArray(files)) {
      files.forEach(file => {
        formData.append('images', file);
      });
    } else {
      formData.append('images', files);
    }
    
    // Add optional parameters
    if (options.saveToDb !== undefined) {
      formData.append('saveToDb', options.saveToDb);
    }
    
    if (options.titles && Array.isArray(options.titles)) {
      formData.append('titles', JSON.stringify(options.titles));
    }
    
    return this.api.post('/api/tailspin/upload/images', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  bulkSaveTailspinImages(images, replace = false) {
    return this.api.post('/api/tailspin/upload/images/bulk-save', {
      images,
      replace
    });
  }

  validateAndDeployImageUrl(url, title = '') {
    return this.api.post('/api/tailspin/upload/validate-url', { url, title });
  }

  // Tailspin Collateral
  getTailspinCollaterals(params = {}) {
    const { page, pageSize, search } = params;
    const queryParams = new URLSearchParams();
    
    if (page) queryParams.append('page', page);
    if (pageSize) queryParams.append('pageSize', pageSize);
    if (search) queryParams.append('search', search);
    
    const queryString = queryParams.toString();
    return this.api.get(`/api/tailspin/collateral${queryString ? `?${queryString}` : ''}`);
  }

  generateTailspinPlaybook(playbookData) {
    return this.api.post('/api/tailspin/intelligence/playbook', playbookData);
  }

  getUserIntelligence() {
    return this.api.get('/api/tailspin/intelligence/user-intelligence');
  }

  createUserIntelligence(data) {
    return this.api.post('/api/tailspin/intelligence/user-intelligence', data);
  }

  updateUserIntelligence(data) {
    return this.api.put('/api/tailspin/intelligence/user-intelligence', { data });
  }

  createTailspinCollateral(collateralData) {
    return this.api.post('/api/tailspin/collateral', collateralData);
  }

  getTailspinCollateralBySlug(slug) {
    return this.api.get(`/api/tailspin/collateral/slug/${slug}`);
  }

  updateTailspinCollateral(id, collateral) {
    return this.api.post('/api/tailspin/collateral/update', {
      id,
      collateral
    });
  }

  updateHtmlCollateral(id, htmlCode) {
    return this.api.post('/api/tailspin/collateral/update', {
      id,
      collateral: { collateral: htmlCode }
    });
  }

  generateCodeCollateral(collateralData) {
    return this.api.post('/api/tailspin/collateral/generate-code', collateralData);
  }

  editCodeCollateral(slug, query, versionIndex = 0) {
    return this.api.post('/api/tailspin/collateral/edit-code', {
      slug,
      query,
      versionIndex
    });
  }

  // Public Tailspin Collateral endpoint (no auth required)
  getTailspinCollateralPublic(slug) {
    return this.publicApi.get(`/api/tailspin/${slug}`);
  }

  // Features - Rephrase
  rephrasePrompt(prompt) {
    return this.api.post('/api/features/rephrase', {
      prompt: prompt
    });
  }

  /**
   * Proxy an image URL through the backend to avoid CORS issues
   * @param {string} imageUrl - The external image URL to proxy
   * @returns {Promise<Blob>} - The image as a blob
   */
  async proxyImage(imageUrl) {
    const proxyUrl = `/api/proxy-logo?url=${encodeURIComponent(imageUrl)}`;
    const response = await this.publicApi.get(proxyUrl, {
      responseType: 'blob',
      timeout: 15000
    });
    return response.data;
  }

  /**
   * Convert an external image URL to a blob URL via backend proxy
   * @param {string} imageUrl - The external image URL
   * @returns {Promise<string|null>} - Blob URL or null if failed
   */
  async imageUrlToBlobUrl(imageUrl) {
    try {
      console.log('🔗 Proxying image:', imageUrl);
      const blob = await this.proxyImage(imageUrl);

      if (blob.size === 0) {
        console.error('❌ Received empty blob');
        return null;
      }

      const blobUrl = URL.createObjectURL(blob);
      console.log('✅ Created blob URL:', blobUrl);
      return blobUrl;
    } catch (error) {
      console.error('❌ Error converting image to blob:', {
        message: error.message,
        status: error.response?.status,
        url: imageUrl
      });
      return null;
    }
  }

  // Admin endpoints - Tenant Management
  createTenant(tenantData) {
    return this.api.post('/api/tenant/create', tenantData);
  }

  getAllTenants() {
    return this.api.get('/api/tenant/get-all');
  }

  getTenantsPaginated(params = {}) {
    const searchParams = new URLSearchParams();
    if (params.page) searchParams.append('page', params.page);
    if (params.pageSize) searchParams.append('pageSize', params.pageSize);
    if (params.search) searchParams.append('search', params.search);
    const query = searchParams.toString();
    const url = query ? `/api/tenant/get-all?${query}` : '/api/tenant/get-all';
    return this.api.get(url);
  }

  // Admin endpoints - User Management
  createUser(userData, tenantId) {
    return this.api.post('/api/user/create', {
      userData: userData,
      tenant_id: tenantId
    });
  }

  getAllUsers() {
    return this.api.get('/api/user/get-all');
  }

  getUsersPaginated(params = {}) {
    const searchParams = new URLSearchParams();
    if (params.page) searchParams.append('page', params.page);
    if (params.pageSize) searchParams.append('pageSize', params.pageSize);
    if (params.search) searchParams.append('search', params.search);
    const query = searchParams.toString();
    const url = query ? `/api/user/get-all?${query}` : '/api/user/get-all';
    return this.api.get(url);
  }

  deleteTenant(tenantId) {
    return this.api.delete(`/api/tenant/${tenantId}`);
  }

  deleteUser(userId) {
    return this.api.delete(`/api/user/${userId}`);
  }

  updateUser(userData) {
    return this.api.post('/api/user/update', userData);
  }

  // Admin endpoints - Proxy Login
  proxyLogin(userId) {
    return this.api.post('/api/auth/proxy-login', {
      userid: userId
    });
  }

  // Admin endpoints - Features Management
  getCollateralFeatures() {
    return this.api.get('/api/tailspin/offerings/features');
  }

  createCollateralFeature(featureData) {
    return this.api.post('/api/admin/features', featureData);
  }

  updateCollateralFeature(featureId, featureData) {
    return this.api.put(`/api/admin/features/${featureId}`, featureData);
  }

  deleteCollateralFeature(featureId) {
    return this.api.delete(`/api/admin/features/${featureId}`);
  }

  // Collateral Templates
  getCollateralTemplates() {
    return this.api.get('/api/tailspin/collateral-template');
  }

  // Admin endpoints - Collateral Types Management
  getCollateralTypes() {
    return this.api.get('/api/tailspin/offerings/collateral-types');
  }

  createCollateralType(collateralTypeData) {
    return this.api.post('/api/admin/collateral-types', collateralTypeData);
  }

  updateCollateralType(collateralTypeId, collateralTypeData) {
    return this.api.put(`/api/admin/collateral-types/${collateralTypeId}`, collateralTypeData);
  }

  deleteCollateralType(collateralTypeId) {
    return this.api.delete(`/api/admin/collateral-types/${collateralTypeId}`);
  }

  // ============================================
  // CRM Analysis Endpoints
  // ============================================

  /**
   * Upload CSV of deals for a tenant (multipart/form-data).
   * @param {FormData} formData  – must include field "file"
   * @param {number}   tenantId
   */
  uploadCrmDealsCsv(formData, tenantId) {
    return this.api.post('/api/crm/import/deals', formData, {
      headers: { 'Content-Type': 'multipart/form-data', 'x-tenant-id': tenantId },
    });
  }

  uploadCrmCallsCsv(formData, tenantId) {
    return this.api.post('/api/crm/import/calls', formData, {
      headers: { 'Content-Type': 'multipart/form-data', 'x-tenant-id': tenantId },
    });
  }

  uploadCrmEmailsCsv(formData, tenantId) {
    return this.api.post('/api/crm/import/emails', formData, {
      headers: { 'Content-Type': 'multipart/form-data', 'x-tenant-id': tenantId },
    });
  }

  /**
   * Run a natural-language deal analysis query.
   * @param {string} userQuery
   * @param {number} tenantId
   */
  runDealAnalysisQuery(userQuery, tenantId, type = 'basic') {
    return this.api.post('/api/crm/deal-analysis/query', { userQuery, tenant_id: tenantId, type });
  }

  /**
   * Fetch all deal_analysis chat threads for a tenant.
   * @param {number} tenantId
   */
  getCrmAnalysisThreads(tenantId) {
    return this.api.get('/api/crm/chat/threads', {
      params: { tenant_id: tenantId, intent: 'deal_analysis' },
    });
  }

  /**
   * Fetch all messages for a thread.
   * @param {number} threadId
   */
  getThreadMessages(threadId) {
    return this.api.get(`/api/crm/chat/threads/${threadId}/messages`);
  }

  // ============================================
  // Subscription Management Endpoints
  // ============================================

  /**
   * Get all available subscription plans
   * @returns {Promise} List of subscription plans
   */
  getSubscriptionPlans() {
    return this.api.get('/api/subscription/plans');
  }

  /**
   * Get current user's subscription details
   * @returns {Promise} Current subscription with plan details
   */
  getCurrentSubscription() {
    return this.api.get('/api/subscription/current');
  }

  /**
   * Check if user has an active subscription
   * @returns {Promise} { hasActiveSubscription: boolean, subscription: object }
   */
  getSubscriptionStatus() {
    return this.api.get('/api/subscription/status');
  }

  getSubscriptionUsage() {
    return this.api.get('/api/subscription/usage');
  }

  /**
   * Create a Stripe checkout session for subscription
   * @param {number} planId - Subscription plan ID
   * @param {number} trialDays - Optional trial period days
   * @returns {Promise} { sessionId, url, customer_id }
   */
  createCheckoutSession(planId, trialDays = null) {
    const payload = { planId };
    if (trialDays) {
      payload.trialDays = trialDays;
    }
    return this.api.post('/api/subscription/create-checkout-session', payload);
  }

  /**
   * Create a Stripe billing portal session
   * @returns {Promise} { url } to Stripe billing portal
   */
  createPortalSession() {
    return this.api.post('/api/subscription/create-portal-session');
  }

  /**
   * Cancel subscription at the end of billing period
   * @returns {Promise} Updated subscription object
   */
  cancelSubscription() {
    return this.api.post('/api/subscription/cancel');
  }

  /**
   * Reactivate a previously canceled subscription
   * @returns {Promise} Updated subscription object
   */
  reactivateSubscription() {
    return this.api.post('/api/subscription/reactivate');
  }

  /**
   * Verify checkout session after payment
   * @param {string} sessionId - Stripe checkout session ID
   * @returns {Promise} Verified subscription details
   */
  verifyCheckoutSession(sessionId) {
    return this.api.get(`/api/subscription/verify-session/${sessionId}`);
  }

  // ============================================
  // Subscription Helper Methods
  // ============================================

  /**
   * Get subscription plans with retry logic
   * @param {number} maxRetries - Maximum retry attempts
   * @returns {Promise} { data, error }
   */
  async getSubscriptionPlansWithRetry(maxRetries = 3) {
    return this.handleApiCall(
      () => this.getSubscriptionPlans(),
      'Failed to fetch subscription plans'
    );
  }

  /**
   * Check if user can access a feature based on subscription
   * @returns {Promise<boolean>} True if user has access
   */
  async hasFeatureAccess() {
    try {
      const response = await this.getSubscriptionStatus();
      return response.data?.data?.hasActiveSubscription || false;
    } catch (error) {
      console.error('Error checking feature access:', error);
      return false;
    }
  }
}

export const apiService = new ApiService();